/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
import warning from 'warning';
var warned = {};
export default function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = "".concat(componentName, ".").concat(propName);
      warning(warned[messageKey], "The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason, "."));
      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(void 0, [props, propName, componentName, location, propFullName].concat(args));
  };
}
/* eslint-disable no-underscore-dangle */

function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/deprecated.js